import { render, staticRenderFns } from "./TabAverage.vue?vue&type=template&id=5c58a806&scoped=true"
import script from "./TabAverage.vue?vue&type=script&lang=js"
export * from "./TabAverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c58a806",
  null
  
)

export default component.exports